export const MAX_INVITATIONS_PER_REQUEST = 1000;
export const INVITATION_EMAIL_BATCH_SIZE = 50;
export const INVITATION_EMAIL_BATCH_INTERVAL_MINUTES = 15;
export const CSV_GROUP_SEPARATOR = ";";
